import {
  useFloating,
  offset,
  shift,
  flip,
  arrow,
  autoUpdate,
  FloatingPortal,
} from '@floating-ui/react';
import { useRef, useState, useCallback } from 'react';
import './Tooltip.scss';

export default function Tooltip({ children, label, placement = 'top' }) {
  const [open, setOpen] = useState(false);
  const arrowRef = useRef(null);
  const touchTimerRef = useRef(null);

  const handleTouchStart = useCallback((e) => {
    e.preventDefault();
    if (touchTimerRef.current) clearTimeout(touchTimerRef.current);
    setOpen(true);
    touchTimerRef.current = setTimeout(() => setOpen(false), 3000);
  }, []);

  const {
    refs,
    floatingStyles,
    placement: finalPlacement,
    middlewareData,
  } = useFloating({
    placement,
    middleware: [
      offset(8),
      flip({ padding: 8, fallbackStrategy: 'bestFit' }),
      shift({ padding: 8 }),
      arrow({ element: arrowRef }),
    ],
    whileElementsMounted: autoUpdate,
  });

  const staticSide = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right',
  }[finalPlacement.split('-')[0]];

  const arrowStyle = {
    left: middlewareData.arrow?.x != null ? `${middlewareData.arrow.x}px` : '',
    top: middlewareData.arrow?.y != null ? `${middlewareData.arrow.y}px` : '',
    [staticSide]: '-4px',
  };

  return (
    <span
      ref={refs.setReference}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onTouchStart={handleTouchStart}
      className='tooltip'
    >
      {children}
      <FloatingPortal>
        <div
          ref={refs.setFloating}
          className={'tooltip-label' + (open ? ' visible' : '')}
          style={floatingStyles}
          role='tooltip'
        >
          {label}
          <div ref={arrowRef} className='tooltip-arrow' style={arrowStyle} />
        </div>
      </FloatingPortal>
    </span>
  );
}
